import Content from '@/components/layout/Content'
import Footer from '@/components/layout/Footer'
import Header from '@/components/layout/Header'
import Wrapper from '@/components/layout/Wrapper'
import { COMMUNITIES } from '@/constants/common'
import { CommunityLinkData } from '@/util/types/CommonType'
import { useTranslation } from 'next-i18next'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'

export default function TermsOfServicePage(props: any) {
  const { t } = useTranslation('translation')
  return (
    <>
      <Wrapper>
        <Content>
          <Header lng={props.locale} />
          <div
            className={`relative h-[calc(100vh-70px)] w-full overflow-hidden pb-[180px]`}
            dangerouslySetInnerHTML={{
              __html:
                '<iframe class="h-[calc(100vh-250px)] w-screen px-4" src="https://ad-banner.walkmining.com/html/terms-of-service.html"></iframe>',
            }}
          />
        </Content>
        <Footer
          noticeTitle={t('about_notice_title')}
          aboutTitle={t('about_service_title')}
          terms={t('service_terms_of_service')}
          privacy={t('service_privacy_title')}
          communities={COMMUNITIES as CommunityLinkData[]}
        />
      </Wrapper>
    </>
  )
}

export async function getServerSideProps(ctx: any) {
  const isSSR = ctx.req !== null && ctx.req !== undefined

  return {
    props: {
      isSSR,
      locale: ctx.locale,
      ...(await serverSideTranslations(ctx.locale, ['translation'])),
    },
  }
}
